import React, { useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import useCountdown from 'hooks/useCountdown'

import { invertColor } from 'utils/colors'

import TextEditor from 'components/TextEditor/TextEditor'

import EditorContext from '../../contexts/editorContext'

import { NAVIGATION_TYPES } from '../../constants'

import styles from './Countdown.module.scss'

const Countdown = ({
    blockData: {
        id,
        t: blockType,
        colorTheme,
        fontFamily,
        isTransparentBackground,
        backgroundColor,
        backgroundImage,
        text,
    },
    onUpdate,
}) => {
    const { t } = useTranslation()
    const editorContext = useContext(EditorContext)
    const [value, setValue] = useState(null)
    const countdown = useCountdown(value)

    const [fontColor, setFontColor] = useState('#000')

    useEffect(() => {
        setFontColor(invertColor(colorTheme))
    }, [colorTheme])

    useEffect(() => {
        if (editorContext.navigationType === NAVIGATION_TYPES.START) {
            setValue(editorContext.projectStructureJson.app.startDate)
        }
    }, [editorContext])

    return (
        <div className={classNames('block', `__${blockType}`)}>
            <div
                className={classNames(styles.wrapper, { [styles.isImageWrapper]: !!backgroundImage })}
                style={{
                    backgroundColor: isTransparentBackground ? 'transparent' : backgroundColor,
                }}
            >
                {backgroundImage && <img className={styles.image} src={backgroundImage} alt="" />}
                <div className={styles.content}>
                    <div className={styles.text}>
                        <TextEditor
                            content={text}
                            onChange={html => {
                                onUpdate({
                                    [id]: {
                                        data: { text: html },
                                    },
                                })
                            }}
                        />
                    </div>
                    <div className={styles.timer}>
                        <ul className={styles.box} style={{ fontFamily, color: fontColor }}>
                            <li className={styles.block} style={{ backgroundColor: colorTheme }}>
                                <span className={styles.amount}>{countdown.days}</span>
                                <span className={styles.unit}>{t('Days')}</span>
                            </li>
                            <li className={styles.block} style={{ backgroundColor: colorTheme }}>
                                <span className={styles.amount}>{countdown.hours}</span>
                                <span className={styles.unit}>{t('Hours')}</span>
                            </li>
                            <li className={styles.block} style={{ backgroundColor: colorTheme }}>
                                <span className={styles.amount}>{countdown.minutes}</span>
                                <span className={styles.unit}>{t('Min')}</span>
                            </li>
                            <li className={styles.block} style={{ backgroundColor: colorTheme }}>
                                <span className={styles.amount}>{countdown.seconds}</span>
                                <span className={styles.unit}>{t('Sec')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Countdown
